module.exports = __webpack_public_path__ + "static/img/03-V-type.8e2d15a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/03-V-type.jpg
// module id = NVNu
// module chunks = 12